import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getPathName } from "../../../common/utils/utilsFunc"
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";

export const DeudaActualYVencidaContext = createContext();

export const ACTIONS = {
    SET_BODY_SC: "SET_BODY_SC",
    SET_SALDO_CROSS: "SET_SALDO_CROSS",
    SET_DEBT_CC: "SET_DEBT_CC",
    SET_BODY_DCC: "SET_BODY_DCC",
    SET_WEB_CONTENT_TEXT: "SET_WEB_CONTENT_TEXT",
    SET_LOAD_PAGE: "SET_LOAD_PAGE",  
    SET_IDLIST: "SET_IDLIST"
};

const initialState = {
    saldoCross: [],
    bodySc: [],
    debtCc: [],
    bodyDcc: [],
    webContentText: "",
    idList: [],
    loadPage: false
};
const DeudaActualYVencidaReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SET_BODY_SC: {
            return {
                ...state,
                bodySc: action.payload,
                };
        }
        case ACTIONS.SET_SALDO_CROSS: {
            return {
                ...state,
                saldoCross: action.payload,
                };
        }
        case ACTIONS.SET_DEBT_CC: {
            return {
                ...state,
                debtCc: action.payload,
                };
        }
        case ACTIONS.SET_BODY_DCC: {
            return {
                ...state,
                bodyDcc: action.payload,
                };
        }
        case ACTIONS.SET_WEB_CONTENT_TEXT: {
            return {
                ...state,
                webContentText: action.payload,
                };
        }
        case ACTIONS.SET_IDLIST: {
          return {
            ...state,
            idList: action.payload,
          };
        }
        case ACTIONS.SET_LOAD_PAGE: {
          return {
            ...state,
            loadPage: action.payload,
          };
        }
        default: {
            return state;
        }
    }
};
const DeudaActualYVencidaContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(DeudaActualYVencidaReducer, initialState);

  const { accessToken } = useContext(AccessTokenContext);
  
  useEffect(() => {
    if(state.bodySc.length > 0 && getPathName() === 'deuda-actual-y-vencida'){
      LiferayService.getSaldoCross(properties.base_url_api, state.bodySc, properties.codigo_empresa, properties.url_ws_empresa)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_SALDO_CROSS,
        });
      })
    }
  }, [state.bodySc]);
  
  useEffect(() => {
    if(state.bodyDcc.length > 0 && getPathName() === 'deuda-actual-y-vencida' && state.saldoCross?.code === 0){
      LiferayService.getDebtCc(properties.base_url_api, state.bodyDcc, properties.url_ws_empresa)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_DEBT_CC,
        });
      })
    }
  }, [state.bodyDcc]);
  
  useEffect(() => {
    if(properties.name_web_content){
      LiferayService.getWebContent(properties.base_url_api,properties.name_web_content)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_WEB_CONTENT_TEXT,
        });
      })
    }
  },[]);

  useEffect(() => {
    if (accessToken) {
      LiferayService.getIdList(properties.base_url_api)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_IDLIST,
          });
          dispatch({
            payload: false,
            type: ACTIONS.SET_LOAD_PAGE,
          });
        })
    }
  }, [accessToken]);

  return (
    <DeudaActualYVencidaContext.Provider value={[state, dispatch]}>
      {children}
    </DeudaActualYVencidaContext.Provider>
  );
};
export default DeudaActualYVencidaContextProvider;